import { useRef } from "react";
import Text from "../Text/Text";
import { useHover } from "ahooks";

export default (node) => {

  const hoverRef = useRef();
  const isHovering = useHover(hoverRef);
  return (
    <div ref={hoverRef} style={{opacity: isHovering ? 1 : .7}}>
      <Text data={node.data} />
    </div>
  );
};
